import { List } from "@mui/material";
import { motion } from "framer-motion";
import { containerVariant, listVariant } from "./Variants";
import NavItem from "./NavItem";
import EmailIcon from "@mui/icons-material/Email";
import { IoHome } from "react-icons/io5";
import { IoIosGitNetwork } from "react-icons/io";

const Navbar = () => {
  const navMenu = [
    {
      id: 1,
      path: "/dashboard",
      icon: <IoHome />,
    },
    {
      id: 2,
      path: "/editprojects",
      icon: <IoIosGitNetwork />,
    },
    {
      id: 3,
      path: "/messages",
      icon: <EmailIcon />,
    },
  ];

  return (
    <nav className="navbar">
      <List
        component={motion.ul}
        variants={containerVariant}
        initial="hidden"
        animate="visible"
      >
        {navMenu.map(({ id, path, icon }) => (
          <NavItem listVariant={listVariant} key={id} path={path} Icon={icon} />
        ))}
      </List>
    </nav>
  );
};

export default Navbar;
